import React from "react";
import { Provider } from "react-redux";
import MisFormatosFrame from "./mis-formatos.frm.js";

export default class MisFormatos extends React.Component {
  render() {
    return (
      <Provider store={this.props.redux}>
        <MisFormatosFrame hashOne={this.props.hashOne} />
        
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/gnp-mis-formatos/mis-formatos.cmpt.js